module.exports = __webpack_public_path__ + "static/media/mistletoe.8e9ee0e3.svg";